var mapBlock = document.getElementById('mapBlock');

var gmarkers = [];
var activeFilters = [];
if (mapBlock) {
  var hotelFilter = document.getElementById('hotelFilter');
  var hotelFilterActive = document.getElementById('hotelFilterActive');
  var resturantFilter = document.getElementById('resturantFilter');
  var resturantFilterActive = document.getElementById('resturantFilterActive');
  var retailFilter = document.getElementById('retailFilter');
  var retailFilterActive = document.getElementById('retailFilterActive');
  var bankFilter = document.getElementById('bankFilter');
  var bankFilterActive = document.getElementById('bankFilterActive');

  hotelFilter.addEventListener('click', function () {
    filterMarkers('hotel');
  });
  resturantFilter.addEventListener('click', function () {
    filterMarkers('resturant');
  });
  retailFilter.addEventListener('click', function () {
    filterMarkers('retail');
  });
  bankFilter.addEventListener('click', function () {
    filterMarkers('bank/transit');
  });
}

//filter marks on click
function filterMarkers(type) {
  if(activeFilters.includes(type)) {
    //reactive markers of type
    activeFilters = activeFilters.filter((e => e !== type));
    gmarkers.map((marker) => {
      if (marker.category == type) {
        marker.setVisible(true);
      }
    });
    updateFilterUIStyle(type, true);
  } else {
    //add to filter array
    activeFilters.push(type);
    updateFilterUIStyle(type, false);
  }

  //filter each item in array
  activeFilters.map(filter => {
    gmarkers.map((marker) => {
      if (marker.category == filter) {
        marker.setVisible(false);
      }
    });
  });
}

//update ui filter active styling
function updateFilterUIStyle(type, active){
    switch (type) {
      case 'hotel':
        if(active){
          hotelFilter.style.opacity = 1.0;
          hotelFilterActive.style.opacity = 1.0;
        } else {
          hotelFilter.style.opacity = 0.8;
          hotelFilterActive.style.opacity = 0.0;
        }
        break;
      case 'resturant':
        if(active){
          resturantFilter.style.opacity = 1.0;
          resturantFilterActive.style.opacity = 1.0;
        } else {
          resturantFilter.style.opacity = 0.8;
          resturantFilterActive.style.opacity = 0.0;
        }
        break;
      case 'retail':
        if(active){
          retailFilter.style.opacity = 1.0;
          retailFilterActive.style.opacity = 1.0;
        } else {
          retailFilter.style.opacity = 0.8;
          retailFilterActive.style.opacity = 0.0;
        }
        break;
      case 'bank/transit':
        if(active){
          bankFilter.style.opacity = 1.0;
          bankFilterActive.style.opacity = 1.0;
        } else {
          bankFilter.style.opacity = 0.8;
          bankFilterActive.style.opacity = 0.0;
        }
        break;
    }
}

(function ($) {
  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find('.marker');
    var plaza;
    $markers.each(function () {
        if ($(this).attr('type') == "plaza") {
          plaza = this;
        }
    });
    var hotels = [];
    $markers.each(function () {
        if ($(this).attr('type') == "hotel") {
          hotels.push(this);
        }
    });
    var resturants = [];
    $markers.each(function () {
        if ($(this).attr('type') == "resturant") {
          resturants.push(this);
        }
    });
    var retails = [];
    $markers.each(function () {
        if ($(this).attr('type') == "retail") {
          retails.push(this);
        }
    });
    var banks = [];
    $markers.each(function () {
        if ($(this).attr('type') == "bank/transit") {
          banks.push(this);
        }
    });

    //custom map style
    var styles = [
      {
        featureType: 'administrative',
        elementType: 'all',
        stylers: [
          {
            hue: '#000000',
          },
          {
            lightness: -100,
          },
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
          {
            hue: '#DDDDDD',
          },
          {
            saturation: -100,
          },
          {
            lightness: -3,
          },
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'labels',
        stylers: [
          {
            hue: '#000000',
          },
          {
            saturation: -100,
          },
          {
            lightness: -100,
          },
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [
          {
            hue: '#000000',
          },
          {
            saturation: -100,
          },
          {
            lightness: -100,
          },
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 26,
          },
          {
            visibility: 'simplified',
          },
          {
            color: '#797575',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 100,
          },
          {
            visibility: 'on',
          },
          {
            color: '#FFFFFF',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            visibility: 'on',
          },
          {
            color: '#393939',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'all',
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 100,
          },
          {
            visibility: 'on',
          },
          {
            color: '#C1C1C1',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'on',
          },
          {
            color: '#FFFFFF',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#959595',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [
          {
            hue: '#000000',
          },
          {
            lightness: -100,
          },
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            hue: '#FFFFFF',
          },
          {
            saturation: -100,
          },
          {
            lightness: 100,
          },
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels',
        stylers: [
          {
            hue: '#000000',
          },
          {
            saturation: -100,
          },
          {
            lightness: -100,
          },
          {
            visibility: 'off',
          },
        ],
      },
    ];

    var styledMap = new google.maps.StyledMapType(styles, {
      name: 'Styled Map',
    });

    // Create gerenic map.
    var mapArgs = {
      zoom: 14,
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    var map = new google.maps.Map($el[0], mapArgs);

    map.mapTypes.set('map_style', styledMap);
    map.setMapTypeId('map_style');

    // Add markers.
    addPlaza(plaza, map);
    hotels.map( (hotel, index) => {
      initMarker(hotel, 'hotel', index, map);
    });
    resturants.map( (resturant, index) => {
      initMarker(resturant, 'resturant', index, map);
    });
    retails.map( (retail, index) => {
      initMarker(retail, 'retail', index, map);
    });
    banks.map( (bank, index) => {
      initMarker(bank, 'bank/transit', index, map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  //add plaza to map
  function addPlaza(plaza, map) {
    // Get position from marker.
    var lat =  plaza.getAttribute('data-lat');
    var lng = plaza.getAttribute('data-lng');
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    new google.maps.Marker({
      position: latLng,
      icon: {
        url: site.theme_path + '/public/images/plazaMarker2.svg',
        scaledSize: new google.maps.Size(110, 110),
        anchor: new google.maps.Point(70, 65),
      },
      category: 'plaza',
      map: map,
    });
  }

  // add markers based on type and index
  function initMarker(marker, type, index, map) {
    // Get position from marker.
    var lat =  marker.getAttribute('data-lat');
    var lng = marker.getAttribute('data-lng');
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    var mIcon = {
      path: google.maps.SymbolPath.CIRCLE,
      fillOpacity: 1,
      fillColor: getFillColor(type),
      strokeOpacity: 1,
      strokeWeight: 1,
      strokeColor: getFillColor(type),
      scale: 12
    };

    //add to map
    var mapMarker = new google.maps.Marker({
      position: latLng,
      category: type,
      map: map,
      icon: mIcon,
      zIndex:99999999,
      label: {
        color: '#FFF', 
        fontSize: '12px', 
        fontWeight: '600',
        text: (index+1).toString(),
      }
    });
    gmarkers.push(mapMarker);
  }

  //helper to get marker color
  function getFillColor(type) {
    switch (type) {
      case 'hotel':
        return '#70171E';
      case 'retail':
        return '#230C0B';
      case 'resturant':
        return '#B59C7C';
      case 'bank/transit':
        return '#415259';
      default:
        return '#70171E';
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    map.setOptions({
      zoomControl: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
    });
    map.setCenter({ lat: 38.648, lng: -90.3327926 });
    map.setZoom(17);
  }

  // Render maps on page load.
  $(document).ready(function () {
    $('.acf-map').each(function () {
      var map = initMap($(this));
    });
  });
})(jQuery);
